<vee-dialog
  key="cookieBannerDialog"
  [required]="true"
  [maxWidth]="(open || cookieService.changeOfRigthsNeeded) ? '3xl' : 'md'"
  class="cookie-banner-dialog"
>
  <ng-container dialog-title>
    <h2>{{ "COMPONENTS.COOKIE_BANNER.TITLE" | translate }}</h2>
  </ng-container>
  <ng-container dialog-content>
    <div class="tw:p-4 tw:flex tw:flex-col tw:items-start">
      @if (!open && cookieService.showSimpleBanner) {
        <header class="tw:min-w-full tw:gap-5 tw:flex tw:flex-col tw:items-center tw:text-center">
          <p class="tw:mb-0 tw:max-w-[70ch] tw:leading-relaxed">
            {{ "COMPONENTS.COOKIE_BANNER.MIN_VIEW.MESSAGE" | translate }}
            <br />
            {{ "COMPONENTS.COOKIE_BANNER.MIN_VIEW.SETTINGS" | translate }}
            <a vee-link class="cyan tw:cursor-pointer hover:tw:underline" (click)="open = !open">
              {{ "COMPONENTS.COOKIE_BANNER.MIN_VIEW.CLICK_HERE" | translate }}
            </a>!
          </p>

          <button vee-btn="filled" class="cyan" (click)="acceptAll()">
            {{ "COMPONENTS.COOKIE_BANNER.ACCEPT_ALL" | translate }}
          </button>
        </header>
      }
      @if (open || cookieService.changeOfRigthsNeeded) {
        <main class="tw:flex tw:flex-col tw:items-start tw:gap-1 tw:w-full">
          <div class="tw:flex tw:justify-between tw:items-center tw:mb-2 tw:p-3 tw:bg-[var(--grey-lightest)] tw:rounded-lg">
            <div class="tw:flex-1">
              <h3 class="tw:text-lg tw:font-semibold tw:mb-1 tw:text-left">{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.PREFERENCES.NAME" | translate }}</h3>
              <p class="tw:text-sm tw:text-[var(--grey-darker)] tw:text-left">{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.PREFERENCES.TEXT" | translate }}</p>
            </div>
            <div class="tw:ml-4">
              <vee-toggle-switch [(ngModel)]="preferences" id="preferences"></vee-toggle-switch>
            </div>
          </div>
          @if (savePreferencesNeeded) {
            <p class="highlight tw:bg-white tw:p-2 tw:border tw:border-[var(--cyan)] tw:mb-4">
              {{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.PREFERENCES.HIGHLIGHT" | translate }}
            </p>
          }
          <div class="tw:flex tw:justify-between tw:items-center tw:mb-2 tw:p-3 tw:bg-[var(--grey-lightest)] tw:rounded-lg">
            <div class="tw:flex-1">
              <h3 class="tw:text-lg tw:font-semibold tw:mb-1 tw:text-left">{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.FUNCTIONAL.NAME" | translate }}</h3>
              <p class="tw:text-sm tw:text-[var(--grey-darker)] tw:text-left">{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.FUNCTIONAL.TEXT" | translate }}</p>
            </div>
            <div class="tw:ml-4">
              <vee-toggle-switch [(ngModel)]="dataconsent" id="dataconsent"></vee-toggle-switch>
            </div>
          </div>
          <div class="tw:flex tw:justify-between tw:items-center tw:mb-2 tw:p-3 tw:bg-[var(--grey-lightest)] tw:rounded-lg">
            <div class="tw:flex-1">
              <h3 class="tw:text-lg tw:font-semibold tw:mb-1 tw:text-left">{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.GOOGLE_ADS.NAME" | translate }}</h3>
              <p class="tw:text-sm tw:text-[var(--grey-darker)] tw:text-left">{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.GOOGLE_ADS.TEXT" | translate }}</p>
            </div>
            <div class="tw:ml-4">
              <vee-toggle-switch [(ngModel)]="google_analytics" id="google_analytics"></vee-toggle-switch>
            </div>
          </div>
          <div class="tw:flex tw:justify-between tw:items-center tw:mb-2 tw:p-3 tw:bg-[var(--grey-lightest)] tw:rounded-lg">
            <div class="tw:flex-1">
              <h3 class="tw:text-lg tw:font-semibold tw:mb-1 tw:text-left">{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.DATA_PROTECTION.NAME" | translate }}</h3>
              <p class="tw:text-sm tw:text-[var(--grey-darker)] tw:text-left">{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.DATA_PROTECTION.TEXT" | translate }}</p>
            </div>
            <div class="tw:ml-4">
              <vee-toggle-switch [(ngModel)]="data_protection" id="data_protection"></vee-toggle-switch>
            </div>
          </div>
          @if (showChatbotMessage) {
            <div class="tw:mt-4 tw:p-4 tw:bg-[var(--red-lightest)] tw:border tw:border-[var(--red-light)] tw:rounded-lg">
              <p class="highlight tw:p-2">
                {{ "COMPONENTS.COOKIE_BANNER.CHATBOT_MESSAGE" | translate }}
              </p>
            </div>
          }
        </main>
      }
    </div>
  </ng-container>
  <ng-container dialog-actions>
    @if (open || cookieService.changeOfRigthsNeeded) {
      <div class="tw:flex tw:flex-col tw:md:flex-row tw:md:justify-center tw:gap-3 tw:p-4 tw:w-full">
        <button vee-btn="filled" class="red tw:w-full tw:md:w-auto" (click)="accept()">
          {{ "COMPONENTS.COOKIE_BANNER.CONFIRM" | translate }}
        </button>
        <button vee-btn="filled" class="cyan tw:w-full tw:md:w-auto" (click)="acceptAll()">
          {{ "COMPONENTS.COOKIE_BANNER.ACCEPT_ALL" | translate }}
        </button>
      </div>
    }
  </ng-container>
</vee-dialog>